module.exports = __webpack_public_path__ + "img/gb9115_26_d.prt.91ed4a41.jpg";